var exports = {
  "kL": "xe533113f--a23e06--container",
  "PS": "xe533113f--a23e06--house",
  "Qq": "xe533113f--a23e06--text",
  "UE": "xe533113f--a23e06--arrow",
};

module.exports = exports;
